/**
 * Extract the Year / month / day of a date object.
 * Return the same Date, with default hours/minutes/seconds to 0
 * */
export const getDayFromDate = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
